// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
function submitVersionForm(event) {
  event.currentTarget.closest("form")?.requestSubmit();
}

/** Submits the compare form when one of its version selects changes. */
export function initializeVersionSelects(root) {
  for (const versionSelect of root.querySelectorAll("[data-behaviour=version-select]")) {
    versionSelect.addEventListener("change", submitVersionForm);
  }
}
